import styled from 'styled-components'

export const ArticleStandardContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-bottom: 1px solid ${p => p.theme.articleBorderColor};
    padding: 10px;
`
